import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { LivestreamBreakoutRoom } from './LivestreamBreakoutRoom';
import { EVENTS_I_HOST } from './SecurityRules';

export interface LivestreamBreakoutRoomParticipantRow {
  id: string;
  breakout_room_id: string;
  identity: string;
  assigned_at: string;
}

export const LivestreamBreakoutRoomParticipant: Entity<LivestreamBreakoutRoomParticipantRow> = {
  id: 'LivestreamBreakoutRoomParticipant',
  title: 'Breakout Room Participant',
  service: 'main',
  rowLabel: (row: LivestreamBreakoutRoomParticipantRow) => row.identity,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.livestream_breakout_room_participant',
  },
  security: [
    {
      role: 'user',
      action: 'read',
      access: 'conditional',
      condition: `identity = '{userId}' OR breakout_room_id IN (SELECT id FROM livestream_breakout_room WHERE livestream_session_id IN (SELECT id FROM livestream_session WHERE event_id IN ${EVENTS_I_HOST}))`,
    },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: `breakout_room_id IN (SELECT id FROM livestream_breakout_room WHERE livestream_session_id IN (SELECT id FROM livestream_session WHERE event_id IN ${EVENTS_I_HOST} OR institution_id = {adminInstitutionId}))`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['assigned_at', 'DESC']],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Text,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
    },
    breakout_room_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Breakout Room',
      refEntity: LivestreamBreakoutRoom,
      mandatory: true,
      listColumn: true,
    },
    identity: {
      seq: 15,
      type: FieldType.Text,
      label: 'Participant Identity',
      mandatory: true,
      listColumn: true,
    },
    assigned_at: {
      seq: 20,
      label: 'Assigned At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
  },
};
